import PricingPage from '../components/PricingPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Pricing | Cartwheel',
  'Compare Cartwheel plans for individuals, teams, and platform workflows, including monthly motion credits and access to creation tools.',
);

export default PricingPage;
